var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    x: 0.5,
    y: 0.5,
    fill: "#E5FAF0",
    rx: 7.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#03964C",
    fillRule: "evenodd",
    d: "M19.507 7.947a.75.75 0 0 1 .046 1.06l-8.25 9a.75.75 0 0 1-1.083.023l-3.75-3.75a.75.75 0 1 1 1.06-1.06l3.196 3.196 7.721-8.423a.75.75 0 0 1 1.06-.046",
    clipRule: "evenodd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    x: 0.5,
    y: 0.5,
    stroke: "#03964C",
    rx: 7.5
  })));
};
export default SvgSuccess;